export default (url: URL) => {
  const localHostnames = ['www.uswitch.com', 'uswitch.com', 'www.money.co.uk', 'www.bankrate.com']

  return localHostnames.includes(url.host)
}
